"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Copy_Button: "Copy",
            Copy_Failed: "Copy failed",
            Copy_Passed: "Copied!",
            Dialog_HideDiagnostic: "Hide diagnostic information",
            Dialog_ShowDiagnostic: "Show diagnostic information",
            MessageBox_BrowserActivityId: "Activity ID: ",
            MessageBox_BrowserInteractionTimestamp: "Search timestamp: ",
            MessageBox_BrowserSessionActivityId: "Session ID: ",
            MessageBox_Cancel: "Cancel",
            MessageBox_Close: "Close",
            MessageBox_LessText: "Fewer Details",
            MessageBox_MessageList: "Messages in list.",
            MessageBox_MoreText: "More Details",
            MessageBox_MultipleMessages: "You've received multiple errors.",
            MessageBox_No: "No",
            MessageBox_NoToAll: "No To All",
            MessageBox_Ok: "OK",
            MessageBox_Tenant: "Tenant ID: ",
            MessageBox_Yes: "Yes",
            MessageBox_YesToAll: "Yes To All",
        },
    });
    var MessageBoxDefaults = {
        callback: undefined,
        ImageName: undefined,
        ImageType: undefined,
        SecondaryText: "",
        showCancelButton: false,
        showCloseButton: false,
        showNoButton: false,
        showNoToAllButton: false,
        showOkButton: false,
        showTelemetryData: false,
        showYesButton: false,
        showYesToAllButton: false,
        Text: "",
        Visible: true,
    };
    $dyn.ui.defaults.MessageBox = MessageBoxDefaults;
    var controls;
    (function (controls) {
        /**
         * Framework base class for MessageBox controls
         * @internal
         */
        var MessageBox = /** @class */ (function (_super) {
            __extends(MessageBox, _super);
            function MessageBox(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $dyn.ui.applyDefaults(_this, data, $dyn.ui.defaults.MessageBox);
                $dyn.shell.activeMessageBox = _this;
                _this.callbacks = [];
                if ($dyn.value(_this.callback)) {
                    _this.callbacks = _this.callbacks.concat($dyn.value(_this.callback));
                }
                _this.HasMultipleMessages = $dyn.computed(function () {
                    var list = $dyn.value(_this.Messages);
                    return list.length > 1;
                });
                _this.TitleText = $dyn.computed(function () {
                    var hasMultipleMessages = _this.HasMultipleMessages();
                    if (hasMultipleMessages) {
                        return $dyn.label("MessageBox_MultipleMessages");
                    }
                    else {
                        var text = $dyn.value(_this.Text);
                        if (!text) {
                            return "";
                        }
                        if (text.length === 1) {
                            return text[0];
                        }
                        return text;
                    }
                });
                _this.BrowserSessionActivityId = $dyn.computed(function () {
                    return $dyn.format("{0} {1}", $dyn.label("MessageBox_BrowserSessionActivityId"), $dyn.browserActivity.BrowserSessionActivity.Id);
                });
                _this.AOSRoleInstance = $dyn.computed(function () {
                    var aosRoleInstance = $dyn.browserActivity.AOSRoleInstance;
                    return aosRoleInstance;
                });
                _this.BrowserInteractionTimestamp = $dyn.computed(function () {
                    return $dyn.format("{0} {1}", $dyn.label("MessageBox_BrowserInteractionTimestamp"), $dyn.browserActivity.BrowserInteractionActivity.UtcTimestamp);
                });
                _this.ShowSessionId = $dyn.computed(function () {
                    return !$dyn.browserActivity.SearchTraceLog;
                });
                _this.ShowSessionIdAnchor = $dyn.computed(function () {
                    return $dyn.browserActivity.SearchTraceLog;
                });
                _this.buildInformation = $dyn.util.getBuildString();
                _this.showTelemetryData = $dyn.observable(false);
                _this.groupFrameOption = $dyn.observable(0);
                _this.groupLabel = $dyn.computed(function () { return $dyn.value(_this.groupFrameOption) ? $dyn.label("Dialog_HideDiagnostic") : $dyn.label("Dialog_ShowDiagnostic"); });
                _this.Messages = $dyn.observableArray([]);
                if ($.isArray($dyn.value(_this.Text))) {
                    _this.addMessages($dyn.value(_this.Text));
                }
                else {
                    _this.Messages.push({ Value: 0, Label: $dyn.value(_this.Text) });
                }
                return _this;
            }
            MessageBox.prototype.addMessage = function (text, callback) {
                this.Messages.push({ Value: $dyn.length(this.Messages), Label: text });
                if (callback) {
                    this.callbacks.push(callback);
                }
            };
            MessageBox.prototype.addMessages = function (messages, callbacks) {
                if (!messages) {
                    return;
                }
                // If there's only one message, put it in an array
                if (!$.isArray(messages)) {
                    messages = [messages];
                }
                // Add the new messages to the list
                var msgArray = new Array();
                var numMessages = $dyn.length(this.Messages);
                for (var i = 0; i < messages.length; i++) {
                    if (messages[i]) {
                        msgArray.push({ Value: numMessages + i, Label: messages[i].text || messages[i] });
                    }
                }
                this.Messages(this.Messages().concat(msgArray));
                if (callbacks) {
                    this.callbacks = this.callbacks.concat(callbacks);
                }
            };
            MessageBox.prototype.buttonClicked = function (button) {
                $dyn.shell.activeMessageBox = undefined;
                $dyn.shell.dialogBack();
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < this.callbacks.length; i++) {
                    var callback = this.callbacks[i];
                    $dyn.getFunction(callback)(button);
                }
            };
            return MessageBox;
        }($dyn.ui.Container));
        controls.MessageBox = MessageBox;
        (function (MessageBox) {
            var Button;
            (function (Button) {
                Button[Button["Close"] = 0] = "Close";
                Button[Button["Yes"] = 1] = "Yes";
                Button[Button["YesToAll"] = 2] = "YesToAll";
                Button[Button["No"] = 3] = "No";
                Button[Button["NoToAll"] = 4] = "NoToAll";
                Button[Button["Ok"] = 5] = "Ok";
                Button[Button["Cancel"] = 6] = "Cancel";
            })(Button = MessageBox.Button || (MessageBox.Button = {}));
            var ButtonName;
            (function (ButtonName) {
                ButtonName["Close"] = "Close";
                ButtonName["Yes"] = "Yes";
                ButtonName["YesToAll"] = "YesToAll";
                ButtonName["No"] = "No";
                ButtonName["NoToAll"] = "NoToAll";
                ButtonName["Ok"] = "Ok";
                ButtonName["Cancel"] = "Cancel";
            })(ButtonName = MessageBox.ButtonName || (MessageBox.ButtonName = {}));
        })(MessageBox = controls.MessageBox || (controls.MessageBox = {}));
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageBox.js.map
